/* eslint-disable react/prop-types,react/jsx-closing-tag-location,import/extensions */
import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import momentTz from 'moment-timezone';
import { Form, Input, Select, Button, Icon, Radio, Tooltip } from 'antd';
import { intlShape, injectIntl } from 'react-intl';
import { FORM_LAYOUT_CONFIG, FORM_FOOTER_CONFIG, VALID_PHONE_NUMBER} from 'config/app.config.js';
import { getExistRule, validator } from 'utils/validateMessagesUtil';
import PERMISSIONS from 'config/app-permission.config';
import { connect } from 'react-redux';


const { Search } = Input;
class userForm extends React.Component {
  state = {
    countryCodeFormatted: []
  };

  componentDidMount() {
    this.loadCountryCodeList();
  }

  onSubmit() {
    const {
      editObject, addUsers, updateUsers, form, selectedDepartmentId, onSubmit,
    } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      const phone_country = values.phone_country && values.phone_country.includes('+') ? +values.phone_country.split('+')[1] : '';
      const authentication_method = values.authentication_method === 'none' ? null : values.authentication_method;
      const submitFormData = { ...values, phone_country, authentication_method, team_id: selectedDepartmentId };


      if (!err) {
        if (_.isEmpty(editObject)) {
          addUsers(submitFormData, () => {
            form.resetFields();
            onSubmit();
          });
        } else {
          updateUsers(submitFormData, () => {
            form.resetFields();
            onSubmit();
          });
        }
      }
    });
  }
  onCancel() {
    this.props.onCancel();
  }
  loadCountryCodeList = async () => {
    const countryCodeFormatted = await this.props.getCountryCallingCode();
    this.setState({ countryCodeFormatted });
  }
  toggleDepartment() {
    const { toggleDepartmentDialog } = this.props;
    toggleDepartmentDialog(true);
  }
  handleCountryCodeSearch = (searchTerm) => {
    const { countryCodeFormatted } = this.state;
    if (!searchTerm) {
      this.loadCountryCodeList();
    } else if (typeof searchTerm === 'string') {
      const searchTermTrimmed = searchTerm.replace('+', '').trim();
      let filteredCountryCodeList = [];
      if (!Number.isNaN(+searchTermTrimmed)) {
        filteredCountryCodeList = countryCodeFormatted.filter(({ calling_code }) => !!calling_code && calling_code.includes(searchTermTrimmed));
      } else {
        filteredCountryCodeList = countryCodeFormatted.filter(({ country }) => !!country && country.toLowerCase().includes(searchTermTrimmed.toLowerCase()));
      }
      this.setState({ countryCodeFormatted: filteredCountryCodeList });
    }
  }
  shouldDisableMobileAuthMethod = () => {
    const { form } = this.props;
    const { getFieldValue } = form;
    return !getFieldValue('phone_country') || !getFieldValue('phone_number');
  };
  getPhoneCountryInitValue = (calling_code) => {
    if (!calling_code) return '';
    const countryData = this.state.countryCodeFormatted.find(country => country.calling_code === `${calling_code}`);
    if (countryData) {
      const { country } = countryData;
      return `${country} +${calling_code}`;
    }
    return '';
  };
  validatePaste = (e) => {
    const key = e.clipboardData.getData('text');
    if (!VALID_PHONE_NUMBER.test(key)) {
      e.preventDefault();
      return false;
    }
  }
  handlePhoneNumberInput = (e) => {
    if(!VALID_PHONE_NUMBER.test(e.key)) {
      e.preventDefault();
    }
  }

  render() {
    const { Item: FormItem } = Form;
    const { Option } = Select;
    const { formatMessage, locale } = this.props.intl;
    const { getFieldDecorator } = this.props.form;
    const {
      disableSubmitBtn,
      editObject,
      timeZones,
      moments,
      selectedDepartmentText,
      selectedDepartmentId,
    } = this.props;
    const formItemLayout = FORM_LAYOUT_CONFIG;

    const days = [
      { text: '30 days', value: 30 },
      { text: '60 days', value: 60 },
      { text: '90 days', value: 90 },
      { text: '180 days', value: 180 },
      { text: '365 days', value: 365 },
      { text: 'Unlimited', value: -1 }
    ]

    const timeZoneSelector = getFieldDecorator('time_zone', {
      initialValue: editObject.time_zone || (_.isEmpty(timeZones) ? '' : momentTz.tz.guess()),
    })(<Select>{
            timeZones.map(item => <Option value={item.id} key={item.id}>{item.display_value}</Option>)
        }
    </Select>);
    const expirationDaysSelector = getFieldDecorator('password_expires_days', {
      initialValue: editObject.password_expires_days || ''
    })(<Select disabled={this.props.accountPermissions.indexOf(PERMISSIONS.SETUP_COMPANYPROFILE_USERS_FORCE_PASSWORD_RESET) < 0}>{days.map(item => (
      <Option value={item.value} key={item.text}>
        { item.text }
      </Option>
      ))}
    </Select>);
    const momentsEl = (<Select>{moments.map(item => <Option value={item} key={item}>{item}</Option>)}</Select>);

    return (
      <Form>
        <FormItem>
          {
                        getFieldDecorator('id', {
                            initialValue: editObject.id || '',
                        })(<Input type="hidden" />)
                    }
        </FormItem>
        <FormItem>
          {
                  getFieldDecorator('team_id', {
                      initialValue: selectedDepartmentId || '',
                  })(<Input type="hidden" />)
              }
        </FormItem>
        <FormItem
          {...FORM_LAYOUT_CONFIG}
          label={formatMessage({ id: 'global.form.userName' })}
        >
          {
                        getFieldDecorator('name', {
                            initialValue: editObject.name || '',
                            rules: [
                                getExistRule('required', 'userName', locale, { required: true }),
                                {
                                    validator: validator.between(2, 100, locale),
                                },
                            ],
                        })(<Input />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.email' })}
        >
          {
                  getFieldDecorator('email', {
                      initialValue: editObject.email || '',
                      rules: [
                          getExistRule('required', 'email', locale, { required: true }),
                          getExistRule('email', 'email', locale),
                      ],
                  })(<Input />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.password' })}
        >
          {
                        getFieldDecorator('password', {
                            initialValue: editObject.password || '',
                            rules: [
                                getExistRule('required', 'password', locale, { required: _.isEmpty(editObject) }),
                                {
                                    validator: validator.password(locale),
                                }],
                        })(<Input type="password" />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.countryCode' })}
        >
          {
          getFieldDecorator('phone_country', {
            initialValue: this.getPhoneCountryInitValue(editObject.phone_country),
            })(
              <Select
                showSearch
                allowClear
                notFoundContent={null}
                placeholder={formatMessage({ id: 'global.form.countryCode' })}
                filterOption={false}
                onSearch={this.handleCountryCodeSearch}
              >
                {this.state.countryCodeFormatted.map(({ country, calling_code }, index) => (
                  <Option key={`${country}-${index}`} value={`${country} +${calling_code}`}>{`${country} +${calling_code}`}</Option>
                ))}
              </Select>)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.mobile' })}
        >
          {
          getFieldDecorator('phone_number', {
              initialValue: editObject.phone_number || '',
          })(<Input onKeyPress={(e) => this.handlePhoneNumberInput(e)} onPaste={(e) => this.validatePaste(e)} type="number" allowClear />)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.authenticationMethod' })}
        >
          {getFieldDecorator('authentication_method', {
            initialValue: editObject.authentication_method || 'none',
            })(
              <Radio.Group>
                <Radio value="none">{formatMessage({ id: 'global.form.none' })}</Radio>
                <Radio value="email">{formatMessage({ id: 'global.form.email' })}</Radio>
                <Radio value="mobile" disabled={this.shouldDisableMobileAuthMethod()}>{formatMessage({ id: 'global.form.mobile' })}</Radio>
              </Radio.Group>
            )}
          <Tooltip placement="right" title={formatMessage({ id: 'global.form.mobileTooltip' })}>
            <Icon type="question-circle" />
          </Tooltip>
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.department' })}
        >
          <Search readOnly onClick={() => { this.toggleDepartment(); }} value={selectedDepartmentText} />
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'page.users.ipRestrict' })}
        >
          {getFieldDecorator('ip_restrict', {
                initialValue: editObject.ip_restrict === 0 ? 0 : 1,
              })(<Select>
                <Option value={1}>Yes</Option>
                <Option value={0}>No</Option>
              </Select>)}
        </FormItem>

          <FormItem
            {...formItemLayout}
            label={formatMessage({ id: 'page.users.forceResetPasswordEvery' })}
          >
            { expirationDaysSelector }
          </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.timeZone' })}
        >
          { timeZoneSelector }
        </FormItem>

        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.workingHourStart' })}
        >
          {getFieldDecorator('start_work_time', {
                        initialValue: editObject.start_work_time || '',
                    })(momentsEl)}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={formatMessage({ id: 'global.form.workingHourEnd' })}
        >
          {getFieldDecorator('end_work_time', {
                  initialValue: editObject.end_work_time || '',
              })(momentsEl)}
        </FormItem>
        <FormItem {...FORM_FOOTER_CONFIG}>
          <Button type="primary" disabled={disableSubmitBtn} htmlType="submit" onClick={() => { this.onSubmit(); }}><Icon type="save" />{ formatMessage({ id: 'global.ui.button.save' })}</Button>
          <Button type="danger" className="ml-sm" onClick={() => { this.onCancel(); }}><Icon type="close" />{ formatMessage({ id: 'global.ui.button.cancel' })}</Button>
        </FormItem>
      </Form>
    );
  }
}
userForm.defaultProps = {
  editObject: {},
  selectedDepartment: '',
};
userForm.propTypes = {
  disableSubmitBtn: PropTypes.bool,
  intl: intlShape.isRequired,
  editObject: PropTypes.object,
  addUsers: PropTypes.func.isRequired,
  updateUsers: PropTypes.func.isRequired,
  toggleDepartmentDialog: PropTypes.func.isRequired,
  timeZones: PropTypes.array.isRequired,
  moments: PropTypes.array.isRequired,
  selectedDepartmentText: PropTypes.string,
  selectedDepartmentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
const UserFormWrapper = Form.create()(injectIntl(userForm));

const mapStateToProps = ({ global }) => ({
  accountPermissions: global.permissions,
});

export default connect(mapStateToProps)(UserFormWrapper);



// WEBPACK FOOTER //
// ./src/views/Setup/Users/component/editAndAddForm.js